import { Info } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

/**
 * A one-line instruction. Text uses the secondary color; the icon is a step
 * darker so the guidance is still easy to spot.
 */
export function InlineHint({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "mulish m-0 flex items-center gap-1.5 whitespace-nowrap text-sm text-text-muted max-lg:items-start max-lg:whitespace-normal",
        className,
      )}
    >
      <Info
        className="size-4 shrink-0 text-[#3e4a3c] dark:text-[#d5dccf]"
        aria-hidden
      />
      <span>{children}</span>
    </p>
  );
}
